export enum SystemLoadScaleName {
  residentialLoadScaleFactor = 'residential',
  commercialLoadScaleFactor = 'commercial',
  anchorLoadScaleFactor = 'anchor',
  internalLoadScaleFactor = 'internal load',
  productiveLoadScaleFactor = 'productive',
  publicLoadScaleFactor = 'public',
  otherLoadScaleFactor = 'other'
}
